import moment from 'moment'
import kebabCase from 'lodash.kebabcase'

function trackDuration(secs) {
  if (secs < 3600) {
    return moment.utc(secs * 1000).format('mm:ss')
  }

  return moment.utc(secs * 1000).format('HH:mm:ss')
}

function dateFormat(value) {
  return value && moment(value).format('MMMM Do YYYY')
}

function dateFormatShortMonth(value) {
  return moment(value).format('MMM D YYYY')
}

function lgrDate(value) {
  return moment(value).format('MMM D YYYY')
}

function dateFormatDashboard(value) {
  return moment(value).format('D of MMM YYYY')
}

function dateTimeFormat(value) {
  return moment(value).format('DD/MM/YYYY - HH:mm')
}

function dateFormatYYYYMMDD(value) {
  return moment(value).format('YYYY-MM-DD')
}

function dateFormatStat(start, end) {
  const startMoment = moment(start)
  const endMoment = moment(end || start)
  const endDateFormat = endMoment.format('Do MMMM YYYY')
  const isSameMonth = startMoment.isSame(endMoment, 'month')
  const isSameYear = startMoment.isSame(endMoment, 'year')
  const startDateFormat = `Do${isSameMonth ? '' : ' MMMM'}${isSameYear ? '' : ' YYYY'}`

  return `${startMoment.format(startDateFormat)} - ${endDateFormat}`
}

function isFutureDate(date) {
  return moment(date).isAfter(moment())
}

function titleFormat(str, lineColor) {
  if (!str) return ''
  const text = str.split(' ')
  if (text.length > 2) {
    text[0] = "<span class='" + lineColor + "-line'>" + text[0]
    text[1] = ' ' + text[1] + '</span>'
  } else {
    text[0] = "<span class='" + lineColor + "-line'>" + text[0] + '</span>'
  }

  return text.join(' ')
}

function filterBy(list, value) {
  return list.filter(function (item) {
    return item.indexOf(value) > -1
  })
}

function findBy(list, value) {
  return list.filter(function (item) {
    return item === value
  })
}

function reverse(value) {
  return value.split('').reverse().join('')
}

/**
 * Truncate a string to a specified length
 *
 * @param {string} string - String to be truncated
 * @param {number} [length=40] - Max. length of the string
 * @param {string} [ending=…] - Ending to be appended to the string
 * @param {boolean} [breakWord=true] - End the string at the nearest character or at the nearest word
 * @returns {string} - Truncated string
 * @example truncate('This is a long string', 10) // This is a…
 */
function truncate(string = '', length = 40, ending = '…', breakWord = true) {
  if (string.length <= length) return string
  const maxLength = Math.max(0, length - ending.length)
  if (breakWord) return string.slice(0, maxLength).trim() + ending
  return string.slice(0, string.lastIndexOf(' ', maxLength)).trim() + ending
}

function numberFormat(value) {
  let newValue = value
  if (value >= 1000) {
    const suffixes = ['', 'k', 'm', 'b', 't']
    const suffixNum = Math.floor(('' + value).length / 3)
    let shortValue = ''
    for (let precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat((suffixNum === 0 ? value : value / Math.pow(1000, suffixNum)).toPrecision(precision))
      const dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '')
      if (dotLessShortValue.length <= 2) {
        break
      }
    }
    newValue = shortValue + suffixes[suffixNum]
  }
  return newValue
}

function seoURL(url) {
  if (!url) {
    return url
  }

  const encodedUrl = url
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .substring(0, 32)

  return kebabCase(encodedUrl)
}

function formatNumber(number) {
  const numberFormat = new Intl.NumberFormat(navigator.language, {
    notation: 'compact',
    maximumFractionDigits: 2,
    compactDisplay: 'short',
  })
  return numberFormat.format(number)
}

export {
  truncate,
  trackDuration,
  dateFormat,
  dateTimeFormat,
  dateFormatDashboard,
  dateFormatShortMonth,
  dateFormatYYYYMMDD,
  titleFormat,
  filterBy,
  reverse,
  lgrDate,
  findBy,
  numberFormat,
  seoURL,
  dateFormatStat,
  formatNumber,
  isFutureDate,
}



// WEBPACK FOOTER //
// ./src/filters/index.js